import * as _ from "lodash";
import * as log from "loglevel";
import * as superagent from "superagent";

import { request } from "http";
import { config } from "../config";
import { RootStore } from "../stores/root-store";
import { QueryString } from "./query";

export module Agent{

	const API_ROOT = config.apiServer;


	const handleErrors = (err) => {
		log.debug(err.message, err.status, err.response);
		if(err.status && err.status === 401){
			if(err.response){
				if(err.response.body.reason === 3){
					//don't logout on requirement failure
					return;
				}
				else{
					RootStore.authStore.logout();
				}
			}
			else{
				RootStore.authStore.logout();
			}

		}

		if(err.response){
			throw new Error(err.response.body.message);
		}
		else
		{
			throw new Error(err.message);
		}
	};

	const responseBody = res => {
		if(res.body){
			if(config.agentDebug){
				log.debug(res.body);
			}
		}
		return res.body;
	};

	const tokenPlugin = req => {
		if (RootStore.authStore && RootStore.authStore.jit) {
			req.set("jit", RootStore.authStore.jit);
		}
		// req.set("jst", "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJzaWQiOiIxZjE2MTU2YjAzYThmZGUzZTQ2NGYwZTA3NmFkOTY0ZDdkYTc5ZDA3M2NmNzk0MDk4NmQ4OTdiMjhmY2UwMjg5IiwiaWF0IjoxNjgwMTk1OTI3LCJleHAiOjE2ODAyMDY3Mjd9.SotE2b56scb0cxAUshQQxTxtanN_eQlhHrAoeDjPS9wX9RHxOrsQC6kReuZ6Tqusl_Nt-ylkPBDczEXzuzRaEYrgdw3PQnpEoYFu6UyIEjK3Oh_hvbaU4qzCDkNS6NLRHBOMU7IApDk7rBjqNAFd2yZeQEflziOAx4He7Lz9HanX5tEQ_nHIlq2BwjmU1ui_7SYfvqIzrnlAQ3Os68uKC88BhOpdlZPqfxfslOtm0QhvceJL6QJBKU8DwcPGaoCUVlz-UTrCyZdRxlky7aEQ6eV_-GlK7pkszbwuZpAnbuGWe63Sci5EYIqeWT1itipysv_gEOKuwwSnem4Vzu3Ajw");
	};

	const logPlugin = req => {
		if(config.agentDebug){
			log.debug(req.method, req.url, req.body ? req.body : "");
		}
	};


	const requests = {
		"del": url =>
			superagent
				.del(`${API_ROOT}${url}`)
				.withCredentials()
				.use(tokenPlugin)
				.use(logPlugin)
				.then(responseBody, handleErrors),
		"get": url =>
			superagent
				.get(`${API_ROOT}${url}`)
				.withCredentials()
				.use(tokenPlugin)
				.use(logPlugin)
				.then(responseBody, handleErrors),
		"put": (url, body) =>
			superagent
				.put(`${API_ROOT}${url}`, body)
				.withCredentials()
				.set("Content-Type", "application/json")
				.use(tokenPlugin)
				.use(logPlugin)
				.then(responseBody, handleErrors),
		"delete": (url) =>
			superagent
				.delete(`${API_ROOT}${url}`)
				.withCredentials()
				.set("Content-Type", "application/json")
				.use(tokenPlugin)
				.use(logPlugin)
				.then(responseBody, handleErrors),
		"post": (url, body = null) =>
			superagent
				.post(`${API_ROOT}${url}`, body)
				.withCredentials()
				.set("Content-Type", "application/json")
				.use(tokenPlugin)
				.use(logPlugin)
				.then(responseBody, handleErrors)
	};

	// tslint:disable-next-line:variable-name
	export const User = {
		"getOptions": () => requests.get(`user/options`),
		"saveOptions": (options: any) => requests.put(`user/options`, options),
		"get": () => requests.get(`user`),
		"full": () => requests.get(`user/full`),
		"saveProfile": (data) => requests.put(`user/profile`, data),
		"save": (userData: any) => requests.put(`user`, userData),
		"changePassword": (newPass: string) => requests.put(`user/change-password`, {"newPassword": newPass}),
		"getUserApp": (projectId: string) => requests.get(`user/project-apps/${projectId}`),
		"getUserApps": (projectIds: Array<string>) => requests.post(`user/project-apps/`, {"ids": projectIds}),
		"completeSetup": (firstName: string, lastName: string, company: string) => requests.put(`user/setup`, {"firstName": firstName, "lastName": lastName, "company": company}),
		"optIn": (acceptNotification: boolean, acceptMarketing: boolean) => requests.put(`user/opt-in`, {"acceptNotification": acceptNotification, "acceptMarketing": acceptMarketing}),
		"terms": (accept: boolean) => requests.put(`user/terms`, {"accept": accept})
	};

	// tslint:disable-next-line:variable-name
	export const Users = {
		"all": () => requests.get(`users`),
		"get": (userId: string) => requests.get(`users/${userId}`),
		"sync": () => requests.post(`users/sync`),
		"getContactTypes": () => requests.get(`users/contacts/types`),
		"getAccessTypes": () => requests.get(`users/access/types`),
		"verify": (userId: string, code: string) => requests.post(`verify/${userId}`, {"code": code}),
		"sendVerification": (userId: string) => requests.post(`verify/${userId}/send-code`),
		"purge": (userId: string) => requests.post(`users/${userId}/purge`),
		"changePassword": ( body) => requests.put(`user/change-password`, body)
	};

	// tslint:disable-next-line:variable-name
	export const Apps = {
		"all": () => requests.get(`apps`),
		"create": (appData: any) => requests.post(`apps`, appData),
		"save": (appId: string, appData: any) => requests.put(`apps/${appId}`, appData),
		"remove": (appId: string) => requests.del(`apps/${appId}`),
		"get": (appId: string) => requests.get(`apps/${appId}`),
		"getKeys": (appId: string) => requests.get(`apps/${appId}/keys`)
	};


	// tslint:disable-next-line:variable-name
	export const Actions = {
		"create": (actData: any) => requests.post(`actions`, actData),
		"remove": (actId: string) => requests.del(`actions/${actId}`),
		"save": (actId: string, actData: any) => requests.put(`actions/${actId}`, actData),
		"get": (actId: string) => requests.get(`actions/${actId}`),
		"all": (query: any = null) => {
			let queryStr: string = "";
			if(query){
				if(query.appId){
					queryStr += `where[appId]=${query.appId}&`;
				}
			}
			return requests.get(`actions?${queryStr}`);
		}
	};

	// tslint:disable-next-line:variable-name
	export const Auth = {
		"login": (username: string, password: string) => requests.post("login", {"username": username, "password": password}),
		"logout": () => requests.post("logout"),
		"logoutAll": () => requests.post("logout-all"),
		"impersonate": (userId: string) => requests.get(`users/${userId}/impersonate`),
		"resetPassword": (email: string) => requests.post(`${email}/reset`),
		"releaseNewTermsAndConditions": () => requests.post(`ReleaseNewTermsAndConditions`)
	};

	// tslint:disable-next-line:variable-name
	export const Projects = {
		"all": (q: QueryString) => requests.get(`user/member-projects?${q.query}`),
		"get": (id: string) => requests.get(`projects/${id}`),
		"sync": () => requests.post(`projects/sync`),
		"getMembers": (id: string) => requests.get(`projects/${id}/members`),
		"getAccessTypes": () => requests.get(`projects/access/types`),
		"addMember": (projectId: string, username: string) => requests.post(`projects/${projectId}/members`, {
			"username": username
		}),
		"removeMember": (projectId: string, userId: string) => requests.del(`projects/${projectId}/members/${userId}`),
		"search": (query: QueryString, term: string, statusFilter: string = "[]", pmFilter: string = "[]") => requests.post(`projects/search?${query.query}`, {"searchTerm": term, "statusFilter": statusFilter, "pmFilter": pmFilter}),
		"create": (body: {projectName: string, projectNumber: string, companyName: string}) => requests.put(`project`, body),
		"syncNonSurveyData": () => requests.post(`projects/nonSurveySync`),
		"getManager": () => requests.get(`projectmanager`)
	};

	// tslint:disable-next-line:variable-name
	export const ProjectMembers = {
		"getProjectPermissions": (pmId: string) => requests.get(`project-members/${pmId}/permissions`),
		"addProjectPermission": (pmId: string, appId: string) => requests.post(`project-members/${pmId}/permissions/${appId}`),
		"removeProjectPermission": (pmId: string, appId: string) => requests.del(`project-members/${pmId}/permissions/${appId}`),
		"save": (pmId: string, pmData: any) => requests.put(`project-members/${pmId}`, pmData)
	};

	// tslint:disable-next-line:variable-name
	export const ProjectPermissions = {
		"getProjectPermissionActions": (permId: string) => requests.get(`project-permissions/${permId}/actions`),
		"addProjectPermissionAction": (permId: string, actId: string) => requests.post(`project-permissions/${permId}/actions/${actId}`),
		"removeProjectPermissionAction": (permId: string, actId: string) => requests.del(`project-permissions/${permId}/actions/${actId}`)
	};

	// tslint:disable-next-line:variable-name
	export const ReleaseNotes = {
		"get": () => requests.get(`releasenotes`),
		"add": (body) => requests.post(`releasenote`, body)
	};

	// tslint:disable-next-line:variable-name
	export const SystemMessage = {
		"get": () => requests.get(`systemmessage`),
		"add": (body) => requests.post(`systemmessage`, body),
		"delete": (id) => requests.delete(`systemmessage/${id}`),
	};

	// tslint:disable-next-line:variable-name
	export const Admin = {
		"getOptIn": () => requests.get(`emailoptin`),
		"getPurgeList": () => requests.get(`purgelist`),
		"getCodingInfo": (surveyId) => requests.get(`codinginfo/${surveyId}`),
		"getCodingResponse": (taskId) => requests.get(`codingresponse/${taskId}`),
		"getJamPurgeList": () => requests.get(`jampurgelist`),
	};

	// tslint:disable-next-line:variable-name
	// export const PermissionTemplate = {
		// 	"all": () => requests.get(`permission-template`),
		// 	"get": (ptId: string) => requests.get(`permission-template/${ptId}`),
		// 	"create": (ptData: any) => requests.post(`permission-template`, ptData),
		// 	"save": (ptId: string, ptData: any) => requests.put(`permission-template/${ptId}`, ptData),
	// 	"remove": (ptId: string) => requests.del(`permission-template/${ptId}`),
	// 	"addApp": (ptId: string, appId: string) => requests.post(`permission-template/${ptId}/apps/${appId}`),
	// 	"removeApp": (ptId: string, appId: string) => requests.del(`permission-template/${ptId}/apps/${appId}`),
	// 	"addAction": (ptId: string, actId: string) => requests.post(`permission-template/${ptId}/action/${actId}`),
	// 	"removeAction": (ptId: string, actId: string) => requests.del(`permission-template/${ptId}/action/${actId}`),
	// 	"getEnabledApps": (ptId: string) => requests.get(`permission-template/${ptId}/enabled-apps`),
	// 	"getActions": (ptId: string) => requests.get(`permission-template/${ptId}/enabled-apps`)
	// };

	// tslint:disable-next-line:variable-name
	export const ProjectApps = {
		"create": (paData: any) => requests.post(`project-app-control`, paData),
		"remove": (paId: string) => requests.del(`project-app-control/${paId}`),
		"get": (paId: string) => requests.get(`project-app-control/${paId}`),
	};

	// tslint:disable-next-line:variable-name
	export const Audits = {
		"get": (q: QueryString) =>  requests.get(`audits?${q.query}`)
	};
}



// WEBPACK FOOTER //
// ./src/services/agent.ts